import { Country, Utility } from "../model/bill-settings/bill-settings";
import { apiSlice } from "../stores/base/api-slice";

const serviceBaseurl = "/vending/utility";

const billEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getCountries: builder.query<Array<Country>, void>({
			providesTags: ["ProductCategory"],
			query: () => ({
				url: "/countries",
				method: "GET",
			}),
		}),
		getUtilitiesForAdmin: builder.query<Utility, void>({
			query:() => ({
				url: `${serviceBaseurl}/utility-admin`,
				method: "GET",
			}),
			providesTags: ["UtilAdminUtility"],
		}),
		getUtilities: builder.query<Array<Utility>, string>({
			query: countryIsoCode => ({
				url: `${serviceBaseurl}/iso-code/${countryIsoCode}`,
				method: "GET",
			}),
			providesTags: ["Utilities"],
		}),
		getUtilityById: builder.query<Utility, string>({
			query: id => ({
				url: `${serviceBaseurl}/${id}`,
				method: "GET",
			}),
			providesTags: ["Utility"],
		}),
		getVendingUtilities: builder.query<Array<Utility>, string>({
			query: countryIsoCode => ({
				url: `${serviceBaseurl}/vending/${countryIsoCode}`,
				method: "GET",
			}),
			providesTags: ["VendingUtilities"],
		}),
		getUtilitiesByCountryId: builder.query<Array<Utility>, number>({
			query: countryId => ({
				url: `${serviceBaseurl}/country/${countryId}`,
				method: "GET",
			}),
			providesTags: ["Utilities"],
		}),
		updateUtility: builder.mutation<any, FormData>({
			invalidatesTags: ["Utilities"],
			query: formData => ({
				url: serviceBaseurl,
				method: "PUT",
				body: formData,
			}),
		}),
		updateUtilityForAdmin: builder.mutation<any, FormData>({
			invalidatesTags: ["UtilAdminUtility"],
			query: formData => ({
				url: `${serviceBaseurl}/utility-admin`,
				method: "PUT",
				body: formData,
			}),
		}),
	}),
});

export const {
	useGetCountriesQuery,
	useGetUtilitiesForAdminQuery,
	useGetUtilitiesQuery,
	useLazyGetUtilitiesQuery,
	useGetUtilityByIdQuery,
	useLazyGetUtilityByIdQuery,
	useUpdateUtilityMutation,
	useLazyGetUtilitiesByCountryIdQuery,
	useLazyGetVendingUtilitiesQuery,
	useUpdateUtilityForAdminMutation,
} = billEndpoints;
